import React, { ReactNode, useCallback } from 'react';
import { Tooltip } from '@fluentui/react-components';
import joinClasses from 'classnames';

//Unfortunately there's no enum extension in typescript - Tempting to extend 'Direction' in services with 'None' so we can re-use...
export enum CellSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE',
}

type ISortableHeaderCellProps = {
  columnKey: string;
  column: { name: ReactNode; tooltip?: string; styles?: { headerCell?: React.CSSProperties } };
  onSort: Function;
  sortDirection: CellSortDirection;
  sortDescendingFirst?: boolean;
};

const UNICODE_KEYS = {
  [CellSortDirection.Asc]: 9650,
  [CellSortDirection.Desc]: 9660,
};

const SortableHeaderCell = ({
  sortDirection,
  sortDescendingFirst,
  onSort,
  column,
  columnKey,
}: ISortableHeaderCellProps) => {
  const onClick = useCallback(() => {
    let direction;
    switch (sortDirection) {
      case CellSortDirection.Asc:
        direction = sortDescendingFirst ? CellSortDirection.None : CellSortDirection.Desc;
        break;
      case CellSortDirection.Desc:
        direction = sortDescendingFirst ? CellSortDirection.Asc : CellSortDirection.None;
        break;
      case null:
      case undefined:
      case CellSortDirection.None:
      default:
        direction = sortDescendingFirst ? CellSortDirection.Desc : CellSortDirection.Asc;
        break;
    }
    onSort(columnKey, direction);
  }, [columnKey, onSort, sortDescendingFirst, sortDirection]);

  const sortByText = sortDirection === CellSortDirection.None ? '' : String.fromCharCode(UNICODE_KEYS[sortDirection]);

  const className = joinClasses({
    'react-grid-HeaderCell-sortable': true,
    'react-grid-HeaderCell-sortable--ascending': sortDirection === 'ASC',
    'react-grid-HeaderCell-sortable--descending': sortDirection === 'DESC',
  });

  const content = (
    <div className={className} onClick={onClick} style={{ cursor: 'pointer', ...column.styles?.headerCell }}>
      <span className="pull-right">{sortByText}</span>
      {column.name}
    </div>
  );

  const tooltipText = column.tooltip;
  if (tooltipText) {
    return (
      <Tooltip content={tooltipText} relationship="label">
        {content}
      </Tooltip>
    );
  }
  return content;
};

export default SortableHeaderCell;
